import {
  CreativePresignedUrlResponseTypes,
  CreativePresignedUrlTypes,
} from "../../model/creative"
import { api } from "./api"

const API_URL = import.meta.env.VITE_API_URL

export const appApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUnsignedCreativeUrls: build.query<
      Record<string, { asset: string; thumbnail: string }>,
      CreativePresignedUrlTypes
    >({
      query: (data) => {
        let queryParams = ""

        for (let id of data.creative_ids) {
          queryParams += `creative_ids=${id}&`
        }
        return {
          url: `${API_URL}/creative/download_unsigned_url?${queryParams}thumbnail=${data.thumbnail}`,
          method: "GET",
        }
      },
      transformResponse: (resposne: CreativePresignedUrlResponseTypes[]) => {
        const newRes = {
          ...resposne.reduce(
            (a, v) => ({
              ...a,
              [v.creative_id]: {
                asset: v.asset,
                thumbnail: !!v.thumbnail ? v.thumbnail : "",
              },
            }),
            {},
          ),
        }
        return newRes as Record<string, { asset: string; thumbnail: string }>
      },
      providesTags: () => [{ type: "Tags", id: "success" }],
    }),
  }),
})

export const { useLazyGetUnsignedCreativeUrlsQuery } = appApi
